module.exports = __webpack_public_path__ + "static/img/RAP-F_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAP-F_1.png
// module id = pxc+
// module chunks = 0